
const asyncRoutes = [
  {
    path: '/',
    name: 'mian',
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import("@/views/home/home"),
      },
      {
        path: 'seal/manage',
        name: 'seal',
        component: () => import("@/views/seal/manage"),
      },
      {
        path: 'online/work',
        name: 'work',
        component: () => import("@/views/online/work"),
      },
      {
        path: 'online/work/sign',
        name: 'workSign',
        component: () => import("@/views/online/workSign"),
      },
      {
        path: 'online/work/success',
        name: 'workSuccess',
        component: () => import("@/views/online/workSuccess"),
      },
      {
        path: 'sign',
        name: 'sign',
        component: () => import("@/views/sign/index"),
      },
      {
        path: 'finance',
        name: 'finance',
        component: () => import("@/views/finance/index"),
      },
      {
        path: 'finance/approve',
        name: 'financeApprove',
        component: () => import("@/views/finance/approve"),
      },
      {
        path: 'finance/approve/success',
        name: 'financeSuccess',
        component: () => import("@/views/finance/success"),
      },
      {
        path: 'document',
        name: 'document',
        component: () => import("@/views/document/index"),
      },
      {
        path: 'document/sign',
        name: 'documentSign',
        component: () => import("@/views/document/sign"),
      },
      {
        path: 'document/circulate',
        name: 'circulate',
        component: () => import("@/views/document/circulate"),
      },
      {
        path: 'merit',
        name: 'merit',
        component: () => import("@/views/merit/index"),
      },
      {
        path: 'merit/apply',
        name: 'apply',
        component: () => import("@/views/merit/apply"),
      },
      {
        path: 'merit/success',
        name: 'applySuccess',
        component: () => import("@/views/merit/success"),
      },
      {
        path: 'real/face',
        name: 'face',
        component: () => import("@/views/realName/face"),
      },
      {
        path: 'real/isp',
        name: 'isp',
        component: () => import("@/views/realName/isp"),
      },
      {
        path: 'real/bankcard',
        name: 'bankcard',
        component: () => import("@/views/realName/bankcard"),
      },
      {
        path: 'real/payment',
        name: 'payment',
        component: () => import("@/views/realName/payment"),
      },
      {
        path: 'real/authorization',
        name: 'authorization',
        component: () => import("@/views/realName/authorization"),
      },
      {
        path: 'cloud/home',
        name: 'cloud',
        component: () => import("@/views/cloud/index"),
      },
      {
        path: 'cloud/initiate',
        name: 'initiate',
        component: () => import("@/views/cloud/initiate"),
      },
      {
        path: 'cloud/initiate',
        name: 'initiate',
        component: () => import("@/views/cloud/initiate"),
      },
      {
        path: 'cloud/sign',
        name: 'cloudSign',
        component: () => import("@/views/cloud/sign"),
      },
      {
        path: 'portal/home',
        name: 'portal',
        component: () => import("@/views/portal/index"),
      },
      {
        path: 'portal/file',
        name: 'file',
        component: () => import("@/views/portal/file"),
      },
      {
        path: 'portal/sign',
        name: 'portalSign',
        component: () => import("@/views/portal/sign"),
      },
      {
        path: 'validation',
        name: 'validation',
        component: () => import("@/views/validation/index"),
      },
      {
        path: 'validation/forge',
        name: 'falseValidation',
        component: () => import("@/views/validation/falseValidation"),
      },
    ]
  }
];

export default asyncRoutes